import { useDevice } from "../../../useDevice";
import Box from "../../Box";
import Button from "../../Button";

type Props = {
	onPress: () => void;
	label: string;
	disabled?: boolean;
};

const SubmitPteAssessorButton = ({
	onPress,
	label,
	disabled = false,
}: Props) => {
	const { isMobile } = useDevice();
	return (
		<Box flex={1} alignItems="center">
			<Box maxWidth={isMobile ? "100%" : 400} width={"100%"}>
				<Button mode="contained" disabled={disabled} onPress={onPress}>
					{label}
				</Button>
			</Box>
		</Box>
	);
};

export default SubmitPteAssessorButton;
